/**
 * CEFR → numeric difficulty mapping for the placement results screen.
 * Ported from client-native/src/utils/levelMapping.ts (source of truth).
 */
export type CEFRLevel =
  | "No Level"
  | "A0"
  | "A0 - Scratch"
  | "Lower A1"
  | "Upper A1"
  | "Lower A2"
  | "Upper A2"
  | "Lower B1"
  | "Upper B1"
  | "Lower B2"
  | "Upper B2"
  | "Lower C1"
  | "Upper C1"
  | "C2";

export const CEFR_TO_DIFFICULTY_MAP: Record<CEFRLevel, number> = {
  "No Level": 0,
  "A0": 1,
  "A0 - Scratch": 1,
  "Lower A1": 2,
  "Upper A1": 2,
  "Lower A2": 3,
  "Upper A2": 3,
  "Lower B1": 4,
  "Upper B1": 4,
  "Lower B2": 5,
  "Upper B2": 5,
  "Lower C1": 6,
  "Upper C1": 6,
  "C2": 6,
};

export const DIFFICULTY_NAMES: Record<number, string> = {
  0: "All Levels",
  1: "Super Beginner",
  2: "Beginner",
  3: "Upper Beginner",
  4: "Intermediate",
  5: "Upper Intermediate",
  6: "Advanced",
};
